import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
  },
  column: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  columnItem: {
    marginBottom: theme.spacing(4),
  },
  tab: {
    fontSize: 18,
    cursor: 'pointer',
    userSelect: 'none',
    position: 'relative',
    display: 'inline-block',
    marginRight: theme.spacing(6),
  },
  activeTab: {
    color: theme.palette.primary.main,
  },
  badge: {
    top: 0,
    right: -25,
    position: 'absolute',
  },
})

const isActive = (path, currentTab) => {
  return path && currentTab.indexOf(path) > -1
}

const Tabs = ({
  classes, column, items, onTabClick, currentTab
}) => (
  <div className={classNames(classes.root, column && classes.column)}>
    {items.map((item) => {
      const { label, path, badgeComponent: BadgeComponent } = item

      const active = isActive(item.path, currentTab)

      return (
        label && (
          <div
            key={path}
            className={classNames(
              classes.tab,
              active && classes.activeTab,
              column && classes.columnItem
            )}
            onClick={() => onTabClick(item)}>
            {item.label}
            {BadgeComponent && <BadgeComponent className={classes.badge} />}
          </div>
        )
      )
    })}
  </div>
)

Tabs.defaultTypes = {
  column: false,
}

Tabs.propTypes = {
  column: PropTypes.bool,
  items: PropTypes.array,
  classes: PropTypes.object,
  onTabClick: PropTypes.func,
  currentTab: PropTypes.string,
}

export default withStyles(styles)(Tabs)



// WEBPACK FOOTER //
// ./src/components/molecules/Tabs.js